import { mergeVisitShopItemsByProduct } from './mergeVisitShopItemsByProduct'
import type { IShopOrderCard, IVisitShopItem } from '../redux/shop'

/** Build a Shop pickup card from Current-tab visit items (includes delivered lines). */
export function buildPickupCardFromVisitItems(params: {
  patientId: string
  firstname?: string | null
  lastname?: string | null
  profilePic?: string | null
  visitItems: IVisitShopItem[]
}): IShopOrderCard {
  const merged = mergeVisitShopItemsByProduct(params.visitItems)

  return {
    orderId: params.patientId,
    patientId: params.patientId,
    firstname: params.firstname ?? undefined,
    lastname: params.lastname ?? undefined,
    profilePic: params.profilePic ?? null,
    itemCount: merged.reduce((sum, item) => sum + item.quantity, 0),
    items: merged.map((item) => ({
      orderItemId: item.orderItemIds[0] ?? item.productId,
      productId: item.productId,
      name: item.name,
      imageUrl: item.imageUrl,
      quantity: item.quantity,
    })),
  }
}
